export const GO_LIVE_DATE = 'October 1, 2022';
export const EARLIER_INVOICES_LABEL = `Invoices Earlier Than ${GO_LIVE_DATE}`;
export const AFTER_INVOICES_LABEL = `Invoices After ${GO_LIVE_DATE}`;
export const OK_LABEL = 'Ok';
export const CANCEL_LABEL = 'Cancel';
export const DELETE_LABEL = 'Delete';
export const MAKE_PAYMENT = 'Make a Payment';
export const DRAWER_MAKE_PAYMENT_DEFAULT =
  'Make this the default method for future payments';
